import { atom } from "jotai";

export const isCallOutcomeOpenAtom = atom(false);
